export default "__VITE_ASSET__BBvmd6gY__"